import React from 'react';
import { useNavigate } from 'react-router-dom';
import MissionCard from '../components/MissionCard';
import { useMissionContext } from '../context/MissionContext';

export default function MissionsListPage() {
  const { missions } = useMissionContext();
  const navigate = useNavigate();

  const goMission = (mission) => {
    navigate('/mission/' + encodeURIComponent(mission.id));
  };

  return (
    <>
      <h1 className="page-title">Missions</h1>
      <div className="missions-list">
        {missions.length === 0 ? (
          <div className="no-missions">
            <p>Aucune mission</p>
          </div>
        ) : (
          missions.map((mission) => <MissionCard key={mission.id} mission={mission} onClick={goMission} />)
        )}
      </div>
    </>
  );
}
